import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { RiQuestionLine, RiNotification3Line } from "react-icons/ri";
import DriverList from "../../components/manageVehicle/DriverLists";
import DriverDetails from "../../components/manageVehicle/DriverDetails";
import RecentHistory from "../../components/manageVehicle/ RecentHistory";
import PhotosSection from "../../components/manageVehicle/PhotosSection";
import { driverControlAPI, SendGateCodetoDriver } from "../../services/Networkcall";
import { use, useCallback, useEffect, useState } from "react";
import { errorAlert, successAlert } from "../../components/common/Alert";
import { Loader } from "../../components/common/Loader";
import { useNavigate } from "react-router-dom";
import { AddVehicle } from "../../components/reserve/AddVehicle";
import { AddDriver } from "../../components/reserve/AddDriver";
import { CancelReservationModel } from "../../components/manageVehicle/CancelReservationModel";


const ManageVehiclesDriver = () => {

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1, limit: 10, totalRecords: 1 })
  const [selectedDriver, setSelectedDriver] = useState(null);
  const navigate = useNavigate();
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false);
  const [showAddDriverModal, setShowAddDriverModal] = useState(false);
  const [showCancelReservationModal, setshowCancelReservationModal] = useState(false);
  const [sendingGateCode, setSendingGateCode] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
    const [refetch, setRefetch] = useState(false);


  const pageHandler = useCallback((page) => {
    setPagination((pre) => ({ ...pre, page: page }));
  }, []);

  const fetchDriverControlData = async () => {
    setLoading(true);
    try {
      const res = await driverControlAPI({ page: pagination.page, limit: pagination.limit, search: debouncedSearch });
      if (res?.success) {
        setData(res?.data);
        setSelectedDriver(res?.data?.[0] || null);
        setPagination((pre) => ({ ...pre, totalPages: res?.totalPages, totalRecords: res?.totalRecords }))
      } else {
        errorAlert({ message: res?.message || "Failed to fetch driver control data" });
      }
    } catch (err) {
      console.error("Error fetching driver control data:", err);
      errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to fetch driver control data" });
    } finally {
      setLoading(false);
    }
  };


    useEffect(() => {
        if (refetch) {
            fetchDriverControlData();
            setRefetch(false);
        }
    }, [refetch]);
  
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    fetchDriverControlData();
  }, [debouncedSearch, pagination.page]);

  const handleCreateBooking = useCallback(() => {
    navigate('/reserve-booking')
  }, [navigate]);

  const handleAddVehicle = useCallback(() => {
    setShowAddVehicleModal(true);
  }, []);

  const handleAddDriver = useCallback(() => {
    setShowAddDriverModal(true);
  }, []);

  const handleSendGateCode = async () => {
    setSendingGateCode(true);
    try {
      const res = await SendGateCodetoDriver({ bookingId: selectedDriver?._id });
      if (res?.success) {
        successAlert({ message: res?.message || "Gate code sent to driver successfully" });
      } else {
        errorAlert({ message: res?.message || "Failed to send gate code to driver" });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Failed to send gate code to driver" });
    } finally {
      setSendingGateCode(false);
    }
  }

  const handleExtendParking = () => {
    navigate('/reserve-booking?extend=true', {
      state: {
        data: {
          isExtendBooking: true,
          selectedBooking: selectedDriver,
        }
      }
    });
  }

  const handleCancelReservation = useCallback(() => {
    setshowCancelReservationModal(true);
  }, []);

  return (
    <Container fluid className="mv-page pt-3">
      <Loader show={loading} />
      <div className="top-header">
        <Container fluid>

          <Row className="align-items-center">

            {/* LEFT SIDE */}
            <Col xl={8} lg={8} md={12} className="mb-md-2">
              <h2 className="page-title">Manage Drivers</h2>
              <p className="page-sub">
                View and manage your drivers and their vehicles.
              </p>
            </Col>

            {/* RIGHT SIDE */}
            {/* <Col xl={4} lg={4} md={12} className="text-xl-end text-lg-end d-flex  justify-content-end align-items-center gap-3">

              {/* NEED HELP  
              <div className="need-help">
                <RiQuestionLine />
                <span>Need Help?</span>
              </div>

              {/* NOTIFICATION  
              <div className="notification">
                <RiNotification3Line />

                {/* BADGE  
                <span className="badge-dot">3</span>
              </div>

            </Col> */}

          </Row>

        </Container>
      </div>

      <Row className="g-2">
        {/* LEFT */}
        <Col lg={4}>
          <DriverList
            driverData={data}
            pagination={pagination}
            pageHandler={pageHandler}
            onselectDriver={setSelectedDriver}
            search={search}
            setSearch={setSearch}
          />
        </Col>
        {/* CENTER */}
        <Col lg={6} className="p-md-0">
          <DriverDetails driver={selectedDriver} />
          <Row className="mt-2">
            <Col md={6}>
              {/* <RecentHistory /> */}
            </Col>
            <Col md={6}>
              {/* <PhotosSection /> */}
            </Col>
          </Row>
        </Col>

        {/* EMPTY RIGHT SPACE (as in image) */}
        <Col lg={2}>
          <div className="ap-wrapper">

            {/* ACTION BUTTONS */}
            <div className="ap-card p-3">


              <Button className="ap-btn primary" onClick={handleCreateBooking}>Create Booking</Button>

              <Button className="ap-btn outline" onClick={handleAddVehicle}>Add Vehicle</Button>
              <Button className="ap-btn outline" onClick={handleAddDriver}>Add Driver</Button>

              {selectedDriver?._id && (<>
                <Button className="ap-btn success" variant="success" onClick={handleSendGateCode} disabled={sendingGateCode}>
                  {sendingGateCode ? "Sending..." : "Send Gate Code"}
                </Button>

               {/* <Button className="ap-btn outline h-100" onClick={handleExtendParking} disabled={(selectedDriver?.isBookingExtend && selectedDriver?.bookingType !== "ADMIN") ? true : false}>
                  {selectedDriver?.isBookingExtend ? "Booking already Extended" : "Extend Parking"}
                </Button> */}
              </>)}

              <Button className="ap-btn danger h-100" onClick={handleCancelReservation}>
                Cancel Reservation
              </Button>

              {showAddVehicleModal && (<AddVehicle show={showAddVehicleModal} closeModal={() => setShowAddVehicleModal(false)}/>)}
              {showAddDriverModal && (<AddDriver show={showAddDriverModal} closeModal={() => setShowAddDriverModal(false)} setRefetch={setRefetch} />)}
              {showCancelReservationModal && (<CancelReservationModel show={showCancelReservationModal} closeModal={() => setshowCancelReservationModal(false)} />)}

            </div>

            {/* DRIVER NOTES */}
            {/* <Card className="notes-card">
              <Card.Body className="p-0">

                <div className="notes-header">
                  <h6>Driver Notes</h6>
                  <span>Edit</span>
                </div>

                <p className="notes-text">
                  Prefers spots near the north entrance.<br />
                  Has a refrigerator unit.<br />
                  Call upon arrival.
                </p>

                <div className="notes-footer">
                  Updated by Admin <br />
                  Apr 15, 2026, 2:30 PM
                </div>

              </Card.Body>
            </Card> */}

          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ManageVehiclesDriver;